import { User } from 'api/user/types'
import axios, { AxiosError } from 'axios'
import config from 'config'

import { OctaneLogger } from '../../integrations/datadog/OctaneLogger'
import { defaultLosJsonHeaders } from '../requestHeaders'

export default async function getUsers(page: number) {
    try {
        let url = `${config.API_BASE_URL}/api/v3/users/`

        if (page > 0) url += `?ssam=true&page=${page}`

        const { data } = await axios.get<User[]>(url, {
            withCredentials: true,
            headers: defaultLosJsonHeaders(),
        })

        return data
    } catch (error) {
        const axiosError = error as AxiosError

        OctaneLogger.axiosError(
            `Failed to get users: ${axiosError.message}`,
            axiosError,
        )

        throw new Error(axiosError.message)
    }
}
